import { render, staticRenderFns } from "./ProfileChangeNotifications.vue?vue&type=template&id=6e126758&scoped=true"
import script from "./ProfileChangeNotifications.vue?vue&type=script&lang=js"
export * from "./ProfileChangeNotifications.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeNotifications.vue?vue&type=style&index=0&id=6e126758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e126758",
  null
  
)

export default component.exports